export interface IFsLprCameraInterface {
  camera_id: string;
  pk: string;
  name: string;
  provider: string;
  latitude: number;
  longitude: number;
  heading: number;
  last_event: string;
  last_created: string;
  editable: string[];
}

export interface IFsLprCameraUpdateInterface {
  name?: string;
  latitude?: number;
  longitude?: number;
  heading?: number;
}
